import axios from "./axiosInstance";
import { api } from "./api_route";

export const caseChecklistDocumentsVerificationAPI = async (caseID) => {
  try {
    const response = await axios.post(
      `${api}/caseChecklistTab/caseChecklistDocumentsVerification`,
      { caseID },
    );

    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const bulkChecklistPDFAPI = async (caseIDs, caseTypeID) => {
  try {
    const response = await axios.post(
      `${api}/caseChecklistTab/bulkChecklistPDF`,
      { caseIDs, caseTypeID },
      {
        responseType: "blob",
      },
      {
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    if (error.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      let jsonData;
      try {
        jsonData = JSON.parse(text);
      } catch (e) {
        throw new Error("Failed to download PDF");
      }
      throw new Error(jsonData.error || jsonData.message || "Failed to download PDF");
    }
    throw error;
  }
};

export const caseDocumentViewAPI = async (caseIDs, caseTypeID, checklistID) => {
  try {
    const response = await axios.post(
      `${api}/caseChecklistTab/caseDocView`,
      { caseIDs, caseTypeID, checklistID },
    );
    return response.data;
  } catch (error) {
    if (error.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      let jsonData;
      try {
        jsonData = JSON.parse(text);
      } catch (e) {
        throw new Error("Failed to download PDF");
      }
      throw new Error(jsonData.error || jsonData.message || "Failed to download PDF");
    }
    throw error;
  }
};

export const bulkChecklistExcelAPI = async (values) => {
  try {
    const response = await axios.post(
      `${api}/caseChecklistTab/bulkChecklistExcel`,
      values,
      {
        responseType: "blob",
      },
    );
    return response;
  } catch (error) {
    console.log("Error", error)
    if (error.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      let jsonData;
      try {
        jsonData = JSON.parse(text);
      } catch (e) {
        throw new Error("Failed to download Excel");
      }
      throw new Error(jsonData.error || jsonData.message || "Failed to download Excel");
    }
    throw error;
  }
};

export const getChecklistByCaseTypeIDAPI = async (caseTypeID) => {
  try {
    const response = await axios.post(
      `${api}/caseChecklistTab/getChecklistByCaseTypeID`,
      { caseTypeID }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const checkExportChecklistAPI = async (caseIDs) => {
  try {
    const response = await axios.post(
      `${api}/caseChecklistTab/checkExportChecklist`,
      { caseIDs }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
